import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Divider, Row, Avatar, Col, Card, Descriptions, Breadcrumb, Tag, Table, Space, Button, Switch } from 'antd';
import { getParent } from './parent.reducer';
import { UserOutlined } from '@ant-design/icons';
import { getEcole } from '../ecole/ecole.reducer';
import { getElevesByParent } from '../eleve/eleve.reducer';
import { getSession } from 'app/shared/reducers/authentication';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ParentDetail = (props: RouteComponentProps<{ id: string; ecoleId: string }>) => {
  const dispatch = useAppDispatch();
  const { match } = props;

  const eleveList = useAppSelector(state => state.eleve.entities);
  const handleOpen = () => {
    props.history.push(`${match.url}/update-status`);
  };
  useEffect(() => {
    dispatch(getSession());
    dispatch(getParent(props.match.params.id));
    dispatch(getEcole(props.match.params.ecoleId));
    const entity = {
      id: props.match.params.id,
      ecoleId: props.match.params.ecoleId,
    };
    dispatch(getElevesByParent(entity));
  }, []);

  const parentEntity = useAppSelector(state => state.parent.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);

  const columnsEleve = [
    {
      title: 'Matricule',
      dataIndex: 'matricule',
      key: 'matricule',
    },
    {
      title: 'Prénoms',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/eleve/${props.match.params.ecoleId}/${id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];
  const dataEleves = eleveList
    ?.map((eleve, i) => ({
      id: eleve.id,
      nom: eleve.lastName,
      prenom: eleve.firstName,
      classe: eleve.classe?.nom,
      matricule: eleve.matricule,
      status: eleve.statutPresence,
      etat: eleve.etatPaiement,
    }))
    .reverse();
  return (
    <>
      <Breadcrumb className="p-4">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/parent/${currentEcole && currentEcole.id}`}>Parents</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Row className=" justify-content-center">
          <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 8 }} md={{ span: 5 }}>
            <Descriptions column={1}>
              <Descriptions.Item>
                <Avatar size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }} icon={<UserOutlined />} />
              </Descriptions.Item>
              <Descriptions.Item label="Statut">
                {parentEntity.user.activated === true ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>}
                <Switch size="small" checked={parentEntity.user.activated === true ? true : false} onClick={() => handleOpen()} />
              </Descriptions.Item>
            </Descriptions>
          </Col>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }}>
            <h2 style={{ textAlign: 'center' }} className="p-4">
              {' '}
              {parentEntity.user.firstName} {parentEntity.user.lastName}{' '}
            </h2>
            <span>
              <Descriptions column={1}>
                <Descriptions.Item label="Téléphone">{parentEntity.user.telephone}</Descriptions.Item>
              </Descriptions>
            </span>
          </Col>
        </Row>
      </Card>
      <Card>
        <h5 style={{ textAlign: 'center' }}>Eleves</h5>
        <Table columns={columnsEleve} dataSource={dataEleves} bordered />
      </Card>
    </>
  );
};

export default ParentDetail;
